var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.484,
    height: 24,
    viewBox: "0 0 23.484 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27018",
    "data-name": "Path 27018",
    d: "M11.139,13.461h0l-.929-1.329L2.818,1.56H6l5.965,8.532.929,1.329,7.754,11.091H17.466ZM20.647,0,13.056,8.824,6.993,0H0L9.168,13.343,0,24H2.072l8.016-9.318L16.491,24h6.993L13.976,10.162h0L22.719,0Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitterIcon.587321952ff9e27b43e3ef1db052107f.svg";
export { ForwardRef as ReactComponent };